import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function divider(theme: Theme) {
  return {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.divider,
          transition: 'border-color 0.15s ease',
        },
      },
    },
  };
}
